import {useMemo, useState} from "react";
import TTLCounter from "./TTLCounter";
import {http, HttpParams} from "@firefly/fly-http";
import {useMutation} from "react-query";
// import omitUndefined from "../../../util/omitUndefined";


export interface SendMobileInput {
    mobile: string
}
export interface UseVerifyMobileType {
    send: (input: SendMobileInput) => Promise<void>;
    sendLoading: boolean,
    sendDisabled: boolean;
    sendLabel: string;
}

export default function useVerifyMobile(gameId: string | undefined): UseVerifyMobileType {
    const [lockTTL, setLockTTL] = useState<number>(0);
    const ttlCounter = useMemo(() => {
        return new TTLCounter(60, (ttl: number) => {
            setLockTTL(ttl);
        })
    }, []);
    const {
        mutateAsync: send,
        isLoading: sendLoading,
    } = useMutation<void, any, SendMobileInput>( {
        mutationFn: (input: SendMobileInput) => {
            return http.post("/api/wangame/viewer/game-vip/verify-mobile/send", {
                mobile: input.mobile
            })
        },
        onSuccess: () => {
            ttlCounter.start();
        },
    })
    const sendDisabled = (lockTTL > 0);
    const sendLabel = sendDisabled ? `重新获取 (${lockTTL})` : '获取验证码';




    return {
        send: send,
        sendLoading: sendLoading,
        sendDisabled: sendDisabled,
        sendLabel: sendLabel,
    }

}
